/**
 * messageHistoryExtension — `IMailEditorInsert.showMessageHistory()` 의 NgwEditor extension
 * (PR-N5).
 *
 * TinyMCE 평행: `nine_tinymce_desktop.js` L6966~L6976 의 `window.showMessageHistory` 가 메시지
 * 이력 보기 토글 + `editorMgr.appendMsgHistory` 콜백 호출. NgwEditor 측에서는 별도 노드 추가가
 * 아니라 event trigger 만 필요 — 본 extension 은 노드 없이 `commands.triggerShowMessageHistory`
 * 만 노출한다.
 *
 * ### 사용자 결정 (a) — quotedButton 과의 결합
 *
 * 본 명령은 두 가지를 동시에 수행:
 *   1. `adapter.getHandler()?.messageHistoryAppended?.(true)` — PR-N6 의 event handler 전수
 *      wiring 진입 전에 본 콜백 1건만 사전 노출.
 *   2. `adapter.mail.region.quotedButton.triggerInsert({})` — PR-N4 의 quotedButton 이 install
 *      되어 있고 skip 미설정 상태면 `insertMailLayout` 명령으로 quoted 영역 lazy 삽입. install
 *      미호출 또는 skip 상태면 NoOp (triggerInsert 가 false 반환).
 *
 * 본 결합은 lazy 삽입 트리거 패턴의 자연스러운 흐름 — 사용자가 "메시지 이력 보기" 버튼을 누르는
 * 시점이 곧 quoted 영역을 도입해야 하는 시점. PR-N6 의 event wiring 단계에서 본 콜백이 외부
 * (EmailForm) 의 실제 message history HTML 을 받아 quoted_header / quoted_body content 를 채우는
 * 흐름으로 보강된다.
 */

import type { NgwExtension } from '@ngweditor/react'
import type { NgwEditorAdapter } from '../NgwEditorAdapter'

export function createMessageHistoryExtension(adapter: NgwEditorAdapter): NgwExtension {
  return {
    name: 'message-history',
    commands: {
      triggerShowMessageHistory: (_state, dispatch) => {
        if (dispatch == null) return true

        const handler = adapter.getHandler()
        handler?.messageHistoryAppended?.(true)

        // PR-N4 의 quotedButton 과 자연스러운 결합. install 미호출 / skip 상태면 false 반환되어 NoOp.
        adapter.mail.region.quotedButton.triggerInsert({})

        return true
      },
    },
  }
}
